import { useMemo } from 'react';
import geo from '../../lib/eu_geo.json';

interface Geo { vb: [number, number]; items: Array<{ c: string; n: string; d: string }> }
const GEO = geo as Geo;

/** Geographic EU-markets selector (28 = EU-27 + Switzerland). Markets include CH
 *  (commercial truth — REVIEW-FIXES C-7); the Q16 EU-only field derives from it. */
export function CountrySelector({ selected, editable = false, onChange }:
  { selected: string[]; editable?: boolean; onChange?: (next: string[]) => void }) {
  const set = useMemo(() => new Set(selected), [selected]);
  const [W, H] = GEO.vb;

  function toggle(code: string) {
    if (!editable || !onChange) return;
    const next = new Set(set);
    next.has(code) ? next.delete(code) : next.add(code);
    onChange([...next]);
  }
  function allNone() {
    if (!onChange) return;
    onChange(set.size === GEO.items.length ? [] : GEO.items.map((i) => i.c));
  }

  const sortedList = [...GEO.items].sort((a, b) => (a.n < b.n ? -1 : 1));

  return (
    <div className="ctry" data-editable={editable}>
      <div className="ctry-head">
        <div className="ctry-count"><b>{set.size}</b> of {GEO.items.length} markets selected</div>
        {editable && <button type="button" className="ctry-edit" onClick={allNone}>{set.size === GEO.items.length ? 'Select none' : 'Select all'}</button>}
      </div>
      <div className="ctry-map">
        <svg viewBox={`-6 -6 ${W + 12} ${H + 12}`} width={W} role="img" aria-label="EU markets map">
          <g className="toplayer">
            {GEO.items.map((it) => (
              <path
                key={it.c}
                className={`geo${set.has(it.c) ? ' on' : ''}`}
                d={it.d}
                data-code={it.c}
                onClick={() => toggle(it.c)}
                style={{ cursor: editable ? 'pointer' : 'default' }}
              ><title>{it.n}</title></path>
            ))}
          </g>
        </svg>
      </div>
      <div className="ctry-list">
        {sortedList.map((k) => (
          <label className="ck" key={k.c}>
            <input type="checkbox" checked={set.has(k.c)} disabled={!editable} onChange={() => toggle(k.c)} />
            <span className="code">{k.c}</span><span className="nm">{k.n}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
